// extracted by mini-css-extract-plugin
export default {"template-icon":"InputTemplateBadge_template-icon__9xrQZ","templateIcon":"InputTemplateBadge_template-icon__9xrQZ"};